<script>
	import VideoModal from '../components/modal/VideoModal.svelte';
	import Modal from '../utils/modal.js';
	import Video from '../components/Video.svelte';
	import {baseURL, RESTClient} from '../utils/rest';
    import VideoSlider from '../components/VideoSlider.svelte';
    import { Swiper, SwiperSlide } from 'swiper/svelte';
	import { onMount } from 'svelte';
	let videos = [];
	 const client = new RESTClient();
	 client.get('videos?_limit=-1').then(res => {
         //videos = res;
          videos = res.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
          console.log(videos)
    });
    let toggleFlag = false;
</script>
<div class="top-section videos-section-page banner-section">
	<h1 class="title">Videos</h1>
	<div class="video-page-main">
		{#if videos.length}
			<Video video={videos[0]}/>
		{/if}
	</div>
</div>
<!-- TODO -->
<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-md-12 col-xs-12 videos-slider">
            <h4 class="videos-section-title recent-stream-title">Recent Streams</h4>
            {#if videos.length}
                <VideoSlider>
                    {#each videos.slice(0, 10) as video}
                    <SwiperSlide>
                        <Video {video} classes="video-card"/>
                    </SwiperSlide>
                    {/each}
                </VideoSlider>
                {:else}
                videos not found
            {/if}
        </div>
    </div>
</div> -->

<div class="container">
	<div class="videos-section other-videos-demand">
		<div class="row">
			<div class="col-lg-12 col-sm-12 col-xs-12">
				<h4 class="videos-section-title">Other Videos on demand</h4>
			</div>
		</div>
		<div class="row videos-main-content">
            {#if videos.length}
					{#each videos.slice(1) as video}
					<div class="col-lg-4 col-md-6 col-sm-6">
						<div class="video-container">
							<Video {video}/>
						</div>
					</div>
					{/each}
                {:else}
                videos not found
            {/if}
            
		</div>
		
		{#if videos.length > 13}
			<p on:click|preventDefault="{() => toggleFlag = !toggleFlag}" class="video-seemore ">{!toggleFlag ? 'Load More': 'Load Less'}</p>
		{/if }
        	<span></span>
	</div>
</div>
<!-- <svelte:head>
	<script
		type="module"
		src="https://unpkg.com/svelte-scrollable-card@1.0.2/index.js">
	</script>
</svelte:head> -->

<style>
	.title {
		font-size: 42px;
		font-family: 'Qualcomm Next Medium';
		text-align: center;
		letter-spacing: 0;
		color: #ffffff;
		padding: 80px 0 20px;
	}


	.videos-slider {
		margin: 60px auto;
        /* max-width: 968px; */
	}


	
</style>